import { render, staticRenderFns } from "./BlocksEditor.vue?vue&type=template&id=5d992d82&lang=pug&"
import script from "./BlocksEditor.vue?vue&type=script&lang=js&"
export * from "./BlocksEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports